export const strictEqualsOperator = {
  label: 'is exactly',
  value: 'equals',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value) {
      return null // No filter applied
    }

    return cellValue => {
      return cellValue === filterItem.value // Exact match
    }
  },
}
